/**
 * mwApp.drm module <br>
 * Work with drm
 *
 * @namespace mwApp/drm
 */

import drmConfig from './drm.config'
import DRMAccountsCtrl from './drmAccounts.controller'
import AddDRMAccountCtrl from './addDRMAccount.controller'
import AddDRMProfileCtrl from './addDRMProfile.controller'

export default
angular.module('mwApp.drm', [])
  .config(drmConfig)
  .controller('DRMAccountsCtrl', DRMAccountsCtrl)
  .controller('AddDRMAccountCtrl', AddDRMAccountCtrl)
  .controller('AddDRMProfileCtrl', AddDRMProfileCtrl)
